import { render, staticRenderFns } from "./userDashboardContracts.vue?vue&type=template&id=52794ca2&scoped=true"
import script from "./userDashboardContracts.vue?vue&type=script&lang=js"
export * from "./userDashboardContracts.vue?vue&type=script&lang=js"
import style0 from "./userDashboardContracts.vue?vue&type=style&index=0&id=52794ca2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52794ca2",
  null
  
)

export default component.exports